import { TDropItem } from 'src/types';

interface TStateDrop extends TDropItem {
  primary?: boolean;
}

export const usStateOptions: TStateDrop[] = [
  { value: 'AL', label: 'Alabama', primary: true },
  { value: 'AK', label: 'Alaska', primary: true },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AZ', label: 'Arizona', primary: true },
  { value: 'AR', label: 'Arkansas', primary: true },
  { value: 'AA', label: 'Armed Forces Americas (Except Canada)' },
  { value: 'AE', label: 'Armed Forces Canada, Europe, Middle East, Africa' },
  { value: 'AP', label: 'Armed Forces Pacific' },
  { value: 'CA', label: 'California', primary: true },
  { value: 'CO', label: 'Colorado', primary: true },
  { value: 'CT', label: 'Connecticut', primary: true },
  { value: 'DE', label: 'Delaware', primary: true },
  { value: 'DC', label: 'District of Columbia', primary: true },
  { value: 'FL', label: 'Florida', primary: true },
  { value: 'GA', label: 'Georgia', primary: true },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii', primary: true },
  { value: 'ID', label: 'Idaho', primary: true },
  { value: 'IL', label: 'Illinois', primary: true },
  { value: 'IN', label: 'Indiana', primary: true },
  { value: 'IA', label: 'Iowa', primary: true },
  { value: 'KS', label: 'Kansas', primary: true },
  { value: 'KY', label: 'Kentucky', primary: true },
  { value: 'LA', label: 'Louisiana', primary: true },
  { value: 'ME', label: 'Maine', primary: true },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MD', label: 'Maryland', primary: true },
  { value: 'MA', label: 'Massachusetts', primary: true },
  { value: 'MI', label: 'Michigan', primary: true },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MN', label: 'Minnesota', primary: true },
  { value: 'MS', label: 'Mississippi', primary: true },
  { value: 'MO', label: 'Missouri', primary: true },
  { value: 'MT', label: 'Montana', primary: true },
  { value: 'NE', label: 'Nebraska', primary: true },
  { value: 'NV', label: 'Nevada', primary: true },
  { value: 'NH', label: 'New Hampshire', primary: true },
  { value: 'NJ', label: 'New Jersey', primary: true },
  { value: 'NM', label: 'New Mexico', primary: true },
  { value: 'NY', label: 'New York', primary: true },
  { value: 'NC', label: 'North Carolina', primary: true },
  { value: 'ND', label: 'North Dakota', primary: true },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'OH', label: 'Ohio', primary: true },
  { value: 'OK', label: 'Oklahoma', primary: true },
  { value: 'OR', label: 'Oregon', primary: true },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Pennsylvania', primary: true },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island', primary: true },
  { value: 'SC', label: 'South Carolina', primary: true },
  { value: 'SD', label: 'South Dakota', primary: true },
  { value: 'TN', label: 'Tennessee', primary: true },
  { value: 'TX', label: 'Texas', primary: true },
  { value: 'UM', label: 'U.S. Minor Outlying Islands' },
  { value: 'UT', label: 'Utah', primary: true },
  { value: 'VT', label: 'Vermont', primary: true },
  { value: 'VI', label: 'Virgin Islands, U.S.' },
  { value: 'VA', label: 'Virginia', primary: true },
  { value: 'WA', label: 'Washington', primary: true },
  { value: 'WV', label: 'West Virginia', primary: true },
  { value: 'WI', label: 'Wisconsin', primary: true },
  { value: 'WY', label: 'Wyoming', primary: true },
];
